import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/review-settings`;
const opts = { withCredentials: true };

function RegionRow({ region, initial }) {
  const [val, setVal] = useState(String(initial));
  const [saved, setSaved] = useState(initial);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await axios.put(`${API}/${region}`, { window_days: Number(val) }, opts);
      setSaved(data.window_days);
      toast.success(`${region.toUpperCase()} review window: ${data.window_days ? `${data.window_days} days` : 'no limit'}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail?.[0]?.msg || e?.response?.data?.detail || 'Save failed');
    } finally { setBusy(false); }
  };
  const dirty = val !== String(saved) && val !== '';
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={`review-window-${region}`}>
      <span className="font-mono text-xs text-[#A3C7A8] uppercase w-10">{region}</span>
      <input type="number" min="0" max="365" value={val} onChange={(e) => setVal(e.target.value.replace(/\D/g, '').slice(0, 3))}
        className="w-20 bg-[#050003] border border-[#2A0F3D] focus:border-[#39FF14] font-mono text-sm px-2 py-1 text-white outline-none"
        data-testid={`review-window-input-${region}`} />
      <span className="font-mono text-[11px] text-[#6B8E73]">days after delivery</span>
      <button type="button" disabled={!dirty || busy} onClick={save}
        className="px-2.5 py-1 font-mono text-xs border border-[#39FF14] text-[#39FF14] disabled:opacity-40" data-testid={`review-window-save-${region}`}>
        Save
      </button>
    </div>
  );
}

// Per-region review window; dispatchers see their own region, SA sees all.
export function ReviewWindowSettings() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    axios.get(API, opts).then(({ data }) => setRows(data.regions)).catch(() => setRows([]));
  }, []);
  if (!rows?.length) return null;
  return (
    <div className="border border-[#2A0F3D] bg-[#0C0612] p-3 mb-4 space-y-2" data-testid="review-window-settings">
      <p className="font-mono text-[11px] text-[#6B8E73] uppercase">// Review window · new reviews &amp; edits allowed for this many days after delivery (0 = no limit)</p>
      {rows.map((r) => <RegionRow key={r.region} region={r.region} initial={r.window_days} />)}
    </div>
  );
}
